module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"passReset":"Reset password","newPass":"New password","confirmPass":"Confirm password","reset":"Reset","registration":"Registration","login":"Login"}}')
  delete Component.options._Ctor
}
